module.exports = __webpack_public_path__ + "img/integrations-color.83f736b7.svg";